module.exports = __webpack_public_path__ + "static/media/greenCheck.dac1b31d.svg";